<h2 style="display: flex; font-size: x-large; justify-content: center;">
    Access Denied. Please contact McLane Helpdesk.
</h2>
<a style="display: flex; font-size: x-large; justify-content: center;" href="{{env.base_url}}">
    Click here to return to McLane Connect </a>
